export interface IParcel {
    id?: string;
    name?: string;
    height: number;
    length: number;
    weight: number;
    width: number;
}

export const WaitingForValidParcel: IParcel = {
    height: -2,
    length: -2,
    weight: -2,
    width: -2,
};

export const NotEbayItemParcel: IParcel = {
    height: -1,
    length: -1,
    weight: -1,
    width: -1,
};

export const NotSetParcel: IParcel = {
    height: -3,
    length: -3,
    weight: -3,
    width: -3,
};
export interface IContent {
    type: string;
    value: number;
}
